import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <footer>
            <a href="https://agricolart.it">
                <img className="logo" src="assets/logo/LogoMarce-blanch.png"/>
            </a>
            <strong style={{fontSize: '12px'}}><span>Copyright © 2023 <a href="https://www.linkedin.com/in/alex-ploner-2aa8221bb/">Alex Ploner</a>. All rights reserved.</span></strong>
            <div id={"footer-links"}>
                <div>
                    <a href="https://www.facebook.com/profile.php?id=100057095814442">
                        <svg id="facebook-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/></svg>
                    </a>
                </div>
                <div>
                    <a href="https://instagram.com/agri.col.art?igshid=YTQwZjQ0NmI0OA==">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#feffff" viewBox="0 0 32 32" id="Camada_1" version="1.1"><path d="M22.3,8.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4C23.7,9,23.1,8.4,22.3,8.4z"></path> <path d="M16,10.2c-3.3,0-5.9,2.7-5.9,5.9s2.7,5.9,5.9,5.9s5.9-2.7,5.9-5.9S19.3,10.2,16,10.2z M16,19.9c-2.1,0-3.8-1.7-3.8-3.8 c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8C19.8,18.2,18.1,19.9,16,19.9z"></path> <path d="M20.8,4h-9.5C7.2,4,4,7.2,4,11.2v9.5c0,4,3.2,7.2,7.2,7.2h9.5c4,0,7.2-3.2,7.2-7.2v-9.5C28,7.2,24.8,4,20.8,4z M25.7,20.8 c0,2.7-2.2,5-5,5h-9.5c-2.7,0-5-2.2-5-5v-9.5c0-2.7,2.2-5,5-5h9.5c2.7,0,5,2.2,5,5V20.8z"></path></svg>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
